"use client"

import { Avatar as AvatarPrimitive } from "radix-ui"
import BoringAvatar from "boring-avatars"
import * as React from "react"

import { cn } from "@/lib/utils"

const Colors = ["#150578", "#802FA0", "#DD316C", "#0DA88C", "#FFCD25"]

const Avatar = React.forwardRef<
  React.ComponentRef<typeof AvatarPrimitive.Root>,
  React.ComponentPropsWithoutRef<typeof AvatarPrimitive.Root>
>(({ className, ...props }, ref) => (
  <AvatarPrimitive.Root
    ref={ref}
    className={cn(
      "relative flex h-6 w-6 shrink-0 overflow-hidden rounded-full",
      className,
    )}
    {...props}
  />
))
Avatar.displayName = AvatarPrimitive.Root.displayName

const AvatarImage = React.forwardRef<
  React.ComponentRef<typeof AvatarPrimitive.Image>,
  React.ComponentPropsWithoutRef<typeof AvatarPrimitive.Image>
>(({ className, ...props }, ref) => (
  <AvatarPrimitive.Image
    ref={ref}
    className={cn("aspect-square h-full w-full", className)}
    {...props}
  />
))
AvatarImage.displayName = AvatarPrimitive.Image.displayName

type PropsFrom<T> = T extends React.ComponentType<infer P> ? P : never
interface AvatarFallbackProps
  extends PropsFrom<typeof AvatarPrimitive.Fallback> {
  name: string
  size?: string | number
}
const AvatarFallback = React.forwardRef<
  React.ComponentRef<typeof AvatarPrimitive.Fallback>,
  AvatarFallbackProps
>(({ className, size = 24, name, ...props }, ref) => (
  <AvatarPrimitive.Fallback
    ref={ref}
    className={cn(
      "flex h-full w-full items-center justify-center rounded-full bg-slate-100 dark:bg-slate-800",
      className,
    )}
    {...props}
  >
    <BoringAvatar
      size={size}
      name={name}
      variant="beam"
      // colors={["#1D3B31", "#208368", "#29A383", "#ACDEC8", "#E6F7ED"]}
      colors={Colors}
    />
  </AvatarPrimitive.Fallback>
))
AvatarFallback.displayName = AvatarPrimitive.Fallback.displayName

export { Avatar, AvatarImage, AvatarFallback }
